import React from "react";
import {injectIntl} from "react-intl";

class FieldError extends React.Component {

  getMessageArgs = (error)=>{
    const args = {};
    if (error.args){
      args.value = error.args[0]; // backward compatibility with error message using {value} (with no index)
      error.args.forEach((e, index)=> {
        args[`value${index}`] = e;
      });
    }
    return args;
  }

  render() {
    const {intl: {formatMessage}, error} = this.props;

    if (!error){
      return
    }
    const args = this.getMessageArgs(error);
    return (
      <div className='txt-error'>{formatMessage({id: error.message}, args)}</div>
    )
  }
}

export default injectIntl(FieldError);
